/**
 * @file JobDescriptionIframeSlot.tsx
 *
 * @fileoverview This slot contains functions that can be used to update description component on client's level.
 *
 */

import { Job } from '~/jobiqo/types/types';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';

/**
 * Returns custom parameters for the iframe component.
 *
 * @param {string} src
 *  The source of the iframe.
 * @param {Job} job
 *  The job.
 * @returns {Object | null}
 *  Custom parameters for the iframe component or null.
 */
export default function getIframeClientCustomParams(
  src: string,
  job: Slottable<Job>,
): object | null {
  return null;
}

export { getIframeClientCustomParams };
